<template>
    <div class="background">
        <div>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Top/>
                </el-col>
            </el-row>
            <el-row class="row-main">
                <el-col  :span="14" :offset="5" class="col-main">
                    <div class="div-main">
                        <img src="../assets/images/banner.png" />
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="14" :offset="5">
                    <Footer/>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import Top from './Top';
import Footer from './Footer';
export default {
  name: 'MainPage',
  components: {
      'Top' : Top,
      'Footer' : Footer
  }
}
</script>

<style scoped>
/** 主组件DIV背景,高度铺满页面主DIV */
.background{
    height: 100%;
    /* background: url('https://bing.biturl.top/?resolution=1920&format=image&index=0&mkt=zh-CN'); */
}
.background>div{
    background-color:  rgba(255, 255, 255, 0.5);
    height: 100%;
}
.row-main{
    height: 80%;
    margin: 10px auto;
}
.col-main,.div-main{
    height: 100%;
}
.div-main{
    background-color:  rgba(255, 255, 255, 0.9);
    border-radius: 4px;
}
.div-main>img{
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/MainPage.vue